import {
    CONFIRMED_GET_DISEASE_HISTORY,
  } from "./DiseaseHistoryTypes.js";
  
  import { getDiseaseHistory, formatDiseaseHistory } from "../../services/DiseaseHistoryService";
  import { showErrorAlert, handleError } from "../../services/ErrorHandlingService";
  
  // Get auth token (same pattern as Notes)
  function getAuthToken(getState) {
    const stateToken = getState().auth?.authKey;
    if (stateToken) return stateToken;
  
    const storedUser = localStorage.getItem('userDetails');
    return storedUser ? JSON.parse(storedUser).token : null;
  }
  
  // Action to get disease history
  export function getDiseaseHistoryAction(patient_id) {
    return async (dispatch, getState) => {
      try {
        const response = await getDiseaseHistory(patient_id);
  
        if (response && response.status === 200 && response.data) {
          if (response.data.status === "success" && response.data.data) {
            const historyList = formatDiseaseHistory(response.data.data);
            dispatch({ type: CONFIRMED_GET_DISEASE_HISTORY, payload: historyList });
          } else {
            handleError("Failed to get disease history: Server error");
          }
        } else {
          handleError("Failed to get disease history: Network error");
        }
      } catch (error) {
        console.error("API Error:", error.response || error);
        showErrorAlert("Failed to get disease history");
      }
    };
  }
  